<template>
    <div>
        <div v-if="memberList.length>0" class="page-container-padding ">
            <checkbox-group @change="memberChange" v-model="checks">
                <div class="membersubbody">
                    <div v-for="(item,index) in memberList" :key="item.id" :class="['radiusshadow page-container-padding', item.sex=='女'?'girl':'man']">
                        <div>
                            <div>{{item.name}}</div>
                            <div>{{item.mobile}}</div>
                        </div>
                        <div>
                            <Checkbox  :name="item.riid+'-'+item.sex" :disabled="item.boxdisabled"  shape="square" checked-color="#ff8c5f"  />
                        </div>
                    </div>
                </div>
            </checkbox-group>

            <div class="membersufooter footer page-container-padding">
                <div>
                    {{choiceMember.length}} / {{registermatchinfo.maxcount}} 已选 男 {{boy}}  女 {{girl}}
                </div>
                <Button class="mvbutton" type="warning" round :disabled="disabled" @click="submitmember">确定</Button>
            </div>
        </div>
        <div v-else>

        <div class="line">
        <Divider>暂无数据</Divider>
        </div>

        </div>
    </div>
</template>
<script>
    import './membersubmit.less'
    import {matchinfo,prememberlist,submitmemberinfos} from '@/libs/api'
    import {Button,Divider,CheckboxGroup,Checkbox} from 'vant'
    import {setStorage, getStorage,goBack} from '@/libs/utils'

    export default {
        name: 'userlist',
        components: {
            Button,
            Divider,
            CheckboxGroup,
            Checkbox
        },
        data() {
            return {
                postparams: {},
                boy:0,
                girl:0,
                memberList: [],
                choiceMember: [],
                disabled: true,
                registermatchinfo: {},
                checks: []
            }
        },
        methods:{
            memberChange(e){
                var boy = 0, girl = 0;
                var choiceMember = [];
                e.forEach((item, index) => {
                    item = item.split('-');
                    choiceMember[index] = item[0]*1;
                    if (item[1] == '男') {
                        boy++;
                    }
                    if (item[1] == '女') {
                        girl++;
                    }
                })
                if(choiceMember.length+1>this.registermatchinfo.maxcount)
                {
                    this.memberList.forEach((item)=>{
                        if(choiceMember.indexOf(item.riid)==-1)
                        {
                            item.boxdisabled    =   true;
                            item.state=0;

                        }else{
                            item.state=1;
                        }
                    })

                    this.memberList = this.memberList

                }else{
                    this.memberList.forEach((item)=>{
                        item.boxdisabled    =   false;
                        if(choiceMember.indexOf(item.riid)==-1)
                        {
                            item.state=0;
                        }else{
                            item.state=1;
                        }


                    })

                    this.memberList = this.memberList
                }


                if(choiceMember.length<=this.registermatchinfo.maxcount&&choiceMember.length>=this.registermatchinfo.mincount)
                {
                    this.disabled = false
                }else{
                    this.disabled = true

                }
                this.boy = boy
                this.girl = girl
                this.choiceMember = choiceMember
            },
            submitmember(){
                var params  =   this.postparams;
                params.riids    =   JSON.stringify(this.choiceMember);
                params.categoryid   =   this.registermatchinfo.categoryid;
                submitmemberinfos(params).then((res)=>{
                    if(res.status==200)
                    {
                        goBack()

                    }
                })
            },
            registerMatchinfo: function () {
                matchinfo(this.postparams).then((res) => {
                    if (res.status == 200) {
                        if (res.data) {
                            this.registermatchinfo = res.data
                            this.getmemberList();

                        }

                    } else {
                        this.registermatchinfo = []
                    }

                })
            },
            getmemberList: function () {
                prememberlist(this.postparams).then((res) => {
                    if (res.status == 200) {
                        if (res.data) {

                            var choiceMember    =   [],boy=0,girl=0;
                            res.data.list.forEach((item, index) => {
                                item.attrs.forEach((citem) => {
                                    if (citem.key_name == 'mv_name') {
                                        item.name = citem.value;
                                    }
                                    if (citem.key_name == 'mv_mobile') {
                                        item.mobile = citem.value;
                                    }
                                    if (citem.key_name == 'mv_sex') {
                                        item.sex = citem.value;
                                    }
                                })

                                if(item.state==1)
                                {
                                    choiceMember[index] =   item.riid;
                                    this.checks[index] = item.riid+'-'+item.sex
                                    if(item.sex=='男')
                                    { 
                                        boy++;
                                    }
                                    if(item.sex=='女')
                                    {
                                        girl++;
                                    }
                                }
                            })
                            this.memberList = res.data.list
                            this.choiceMember = choiceMember
                            this.boy = boy
                            this.girl = girl
                            if(choiceMember.length+1>this.registermatchinfo.maxcount)
                            {
                                this.memberList.forEach((item)=>{
                                    if(choiceMember.indexOf(item.riid)==-1)
                                    {
                                        item.boxdisabled    =   true;
                                        item.state=0;

                                    }else{
                                        item.state=1;
                                    }
                                })

                                this.memberList = this.memberList

                            }
                        }
                    }

                })
            }
        },
        mounted() {
            this.$nextTick(() => {
                let userinfo = getStorage('userInfo')
                let param = this.$route.params
                let arr = Object.keys(param);
                if(arr.length == 0){
                  this.postparams = getStorage('membersubmit')
                }else{
                  this.postparams = this.$route.params
                  setStorage('membersubmit',this.postparams,true)
                }
                this.postparams.urid = userinfo.urid
                this.postparams.token = userinfo.token
                this.registerMatchinfo();
            })
        }
    }
</script>